module.exports = __webpack_public_path__ + "img/swiper2.e57ee219.png";